import React, { FC, useEffect, useState } from 'react';
import { Button, Flex } from '@chakra-ui/react';

import { useAlert, useApi, useFetchData } from '@app/hooks';
import { TableBase } from '@app/components/common/table/table-base';
import Dialog from '@app/components/common/modals/dialog';
import { SwitchField, TextField } from '@app/components/common';

import { Table } from '../../common/table/table';
import { useColumns } from './columns';

const EquipmentsUnitsCheckedStatusesTable: FC = () => {
const [units, setUnits] = useState<EntityBase[]>([]);
  const api = useApi();
  const { error } = useAlert();
  const [loading, setLoading] = useState(false);
  const [currentUnit, setCurrentUnit] = useState<EntityBase & { is_active?: boolean }>();
  const [currentDialog, setCurrentDialog] = useState<'edit' | 'create'>();

  const onEdit = (unit: EntityBase & { is_active: boolean }) => {
    setCurrentUnit(unit);
    setCurrentDialog('edit');
  };
  const columns = useColumns({ onEdit });

  useEffect(() => {
    setLoading(true);
    api.guides.checkedStatusList().then(({ data }) => {
      setLoading(false);
      return setUnits(data || []);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (unit: EntityBase & { is_active?: boolean }) => async () => {
    if (unit.name === '' || unit.is_active === undefined) {
      error('Введите название');
      return;
    }
    setLoading(true);
    if (unit.id) {
      await api.guides.checkedStatusUpdate({
        id: unit.id,
        name: unit.name,
        is_active: !!unit.is_active,
      });
    } else {
      await api.guides.checkedStatusCreate({
        name: unit.name,
        is_active: unit.is_active,
      });
    }
    api.guides.checkedStatusList().then(({ data }) => {
      setLoading(false);
      return setUnits(data || []);
    });
    setLoading(false);
    setCurrentUnit(undefined);
    setCurrentDialog(undefined);
  };

  return (
    <>
      <TableBase<EntityBase>
        title="Статусы проверки ХО после ремонта"
        data={units}
        columns={columns}
        loading={loading}
        paper={false}
        onCreateClick={() => {
          setCurrentUnit({});
          setCurrentDialog('create');
        }}
      />
      <Dialog 
        open={!!currentDialog}
        onClose={() => {
          setCurrentUnit(undefined);
          setCurrentDialog(undefined);
        }}
        title={currentDialog === 'edit' ? 'Редактирование' : 'Создание'}
      >
        <Flex gap={2} flexDirection="column">
          <TextField 
            id='name'
            label="Название"
            required
            value={currentDialog === 'edit' ? currentUnit?.name : ''}
            onChange={(value) => {
              setCurrentUnit({
                ...currentUnit,
                name: value
              });
            }}
          />
          <SwitchField 
            label='Активен'
            value={currentUnit?.is_active}
            onChange={(value) => {
              setCurrentUnit({
                ...currentUnit,
                is_active: value
              });
            }}
            id='is_active'
          />  
          <Flex justifyContent="flex-end" gap={2}>
            <Button 
              variant="outline"
              colorScheme="gray"
              onClick={() => {
              setCurrentUnit(undefined);
              setCurrentDialog(undefined);
            }}
            >Отмена</Button>
            <Button 
              variant="solid"
              colorScheme="brand"
              onClick={onSubmit(currentUnit)}
            >Сохранить</Button>
          </Flex>
        </Flex>
      </Dialog>
    </>
  );
};

export default EquipmentsUnitsCheckedStatusesTable;
